import React from "react";
import {
  Box,
  Button,
  Divider,
  InputLabel,
  Modal,
  Typography,
  styled,
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { useEffect } from "react";
import { colorBrandObject } from "../../../constants/brandings";
import CustomButton from "../../reusableComponents/CustomButton";
import FileCopyIcon from "../../../assets/svg/fileCopy.svg";
import DownloadQrIcon from "../../../assets/svg/downloadQr.svg";
import { fileCopyDefaultColor } from "../../reusableComponents/constants";

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const contentStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignItems: "flex-start",
  textAlign: "left",
  width: "416px",
};
const Root = styled("div")(({ theme }) => ({
  width: "100%",
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  "& > :not(style) ~ :not(style)": {
    marginTop: theme.spacing(2),
  },
}));

const imgStyle = {
  width: "100%",
  height: "100%",
};

export default function NotifyModal({ open, onClose, responseData, editData }) {
  useEffect(() => {
    if (open === true && responseData?.url) {
      navigator.clipboard.writeText(responseData?.url);
      customToast("success", "medium", `Copied`);
    }
  }, [open, responseData]);
  const handleCopyClick = () => {
    navigator.clipboard.writeText(responseData.url);
    customToast("success", "medium", `Copied`);
  };
  const style = {
    background: `linear-gradient(to right, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 0 0 , linear-gradient(to right, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 0 100% , linear-gradient(to left, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 100% 0,linear-gradient(to left, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 100% 100%,linear-gradient(to bottom, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 0 0,linear-gradient(to bottom, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 100% 0,linear-gradient(to top, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 0 100%,linear-gradient(to top, ${colorBrandObject?.secondaryButtonColor} 4px, transparent 4px) 100% 100%`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "40px 40px",
    height: "150px",
    width: "150px",
    marginTop: "12px",
    padding: "1px",
    boxSizing: "border-box",
  };
  const handleDownloadQr = () => {
    const qrImageSrc = `data:image/gif;base64,${responseData?.trackingUrls?.QR}`;

    const image = new Image();
    image.src = qrImageSrc;

    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
      const format = "png"; // Change to "jpeg" if needed
      const dataUrl = canvas.toDataURL(`image/${format}`);
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `qr_code.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      customToast("success", "medium", "QR downloaded successfully");
    };

    image.onerror = () => {
      customToast("error", "medium", "Failed to load QR code image");
    };
  };

  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={modalStyle}
      >
        <Box sx={contentStyle}>
          <img
            src="/assets/checkCircle.svg"
            alt="check"
            style={{ marginBottom: "10px" }}
          />
          {editData ? (
            <Typography variant="h6">Payment Link has been updated</Typography>
          ) : (
            <Typography variant="h6">Payment link has been created</Typography>
          )}
          <Typography
            variant="body1"
            style={{ color: "var(--text-medium, rgba(1, 1, 2, 0.60))" }}
          >
            Please find the link below
          </Typography>
          <div style={{ display: "flex", width: "100%", marginBottom: "12px" }}>
            <InputLabel
              disabled
              className="disabledBox"
              sx={{
                marginTop: "10px",
                width: "317px",
                borderRadius: "4px",
                border: "1px solid var(--neutral-5, #D9D9D9)",
                height: "40px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "var(--text-high, rgba(1, 1, 2, 0.72))",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 400,
                  paddingLeft: "10px",
                }}
              >
                {" "}
                {responseData.url}
              </span>
            </InputLabel>
            <div style={{ stroke: fileCopyDefaultColor }}>
              <FileCopyIcon
                stroke={`${colorBrandObject?.secondaryButtonColor}`}
                onClick={handleCopyClick}
                style={{
                  alignItems: "center",
                  height: "24px",
                  borderRadius: "4px",
                  marginLeft: "12px",
                  marginTop: "18px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          <Root>
            <Divider>OR</Divider>
          </Root>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={style}>
              <img
                src={`data:image/gif;base64,${responseData?.trackingUrls?.QR}`}
                alt="qr"
                style={imgStyle}
              />
            </div>
            <div style={{ width: "200px", margin: "12px 0px 0px 32px" }}>
              <Typography className="labelRegular">
                Download this QR and share it with your customers
              </Typography>

              <div style={{ stroke: fileCopyDefaultColor }}>
                <DownloadQrIcon
                  stroke={`${colorBrandObject?.secondaryButtonColor}`}
                  onClick={handleDownloadQr}
                  style={{ marginTop: "8px", cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
          <Button
            type="submit"
            size="smaill"
            className="buttonNotify"
            onClick={onClose}
            style={{
              backgroundColor: `${colorBrandObject?.secondaryButtonColor}`,
            }}
          >
            Done
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
